@if (data) {
    <cerrix-workspace
        data-uiid="finding-report-overview"
        [tabID]="tabID"
        [cerrixTab]="tab"
        [data]="data"
        [headerLookup]="headerLookup"
        [module]="'Findings Report'"
        [moduleType]="moduleType"
        [idProp]="'guid'"
        [permissions]="permissions"
        [filterConfig]="filterConfigs"
        [rendererConfig]="rendererConfig"
        [NumberProperties]="numberProps"
        [DateProperties]="dateProps"
        (onDblClick)="openDetail($event)"
        (onAddClick)="add()"
    >
    </cerrix-workspace>
}
